export default [
  ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', 'ú', 'ã', 'â'],
  ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', 'ç', 'í', 'á', 'à'],
  ['z', 'x', 'c', 'v', 'b', 'n', 'm', 'õ', 'ô', 'ó', 'é', 'ê'],
]
